import MyLeavesTable from './MyLeavesTable';

export default MyLeavesTable;
